<script setup lang="ts">
import { faHourglass } from '@fortawesome/pro-regular-svg-icons';
import type Trip from '@itinerary/trip/Trip';

const { departureTrip, arrivalTrip } = defineProps<IProps>();
interface IProps {
    arrivalTrip: Trip;
    departureTrip: Trip;
}
const durationTime = computed(() =>
    secondsToDurationTime(
        dayConfig
            .gregory(departureTrip.departureDateTime)
            .diff(arrivalTrip.arrivalDateTime, 'second')
    )
);
const originTitle = computed(
    () => `توقف در فرودگاه ${arrivalTrip.destinationTerminal}`
);
</script>

<template>
    <div class="station-waiting-container">
        <div class="time-duration">
            {{ durationTime }}
            <mr-icon :icon="faHourglass" color="var(--cool-gray-500)" />
        </div>
        <mr-divider
            vertical
            class="divider"
            border-style="dashed"
            color="var(--cool-gray-400)"
        />
        <div class="title">
            {{ originTitle }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.station-waiting-container {
    display: flex;
    align-items: stretch;
    margin-top: 8px;
    margin-right: 20px;
}

.time-duration {
    flex-shrink: 0;
    @include tg-m($w5, usePalette($p-cool-gray, 600));
    display: flex;
    justify-content: flex-end;
    margin: 8px 0;
    width: 62px;
}

.divider {
    padding: 0 9px;
    margin-inline: 20px;
}

.title {
    margin: auto 0;
    @include tg-m($color: usePalette($p-cool-gray, 600));
}
</style>
